import { offset } from "@floating-ui/dom";
import { useRef } from "react";

import { useFloatingWindowsActions } from "src/base-components/FloatingWindow/hooks";
import { useCanvasSearchTermParam } from "src/flowGraph/useCanvasSearchTermParam";

export const useFlowGraphSearchWindow = () => {
  "use memo";
  const { open: openWindow } = useFloatingWindowsActions();
  const { setSearchTerm } = useCanvasSearchTermParam();
  const flowGraphSearchTargetRef = useRef<HTMLDivElement | null>(null);

  const openSearchWindow = (searchTerm: string = "") => {
    const nodeEditor = document.querySelector("[data-loc=node-editor-pane]");
    const header = document.querySelector("[data-loc=layout-header]");

    flowGraphSearchTargetRef.current = (nodeEditor ?? header) as HTMLDivElement;

    setSearchTerm(searchTerm);

    openWindow(
      {
        id: "flow-graph-search",
        type: "flow-graph-search",
        target: flowGraphSearchTargetRef,
        positionOptions: {
          placement: nodeEditor ? "left-start" : "bottom-end",
          middleware: [offset({ alignmentAxis: 20, mainAxis: 20 })],
        },
      },
      {},
    );
  };

  return {
    openSearchWindow,
  };
};
